import type React from "react";

type KeyHintProps = {
  children: React.ReactNode;
};

export function KeyHint({ children }: KeyHintProps) {
  return (
    <kbd className="inline-flex h-[22px] min-w-[22px] items-center justify-center rounded-md bg-brand-secondary px-1.5 align-middle font-sans text-xs font-semibold text-brand-400">
      {children}
    </kbd>
  );
}
